import { createSequenceAndChildrenNodes } from '../../functions/utils'

// eslint-disable-next-line
export default async (component, event, ui) => {
  // eslint-disable-next-line
  const sequenceNode = createSequenceAndChildrenNodes(event, ui)
}